import Notification from '../../shared/notification';
import prospectFormHndb from '../templates/prospect-form.handlebars';
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
import { View } from './view';

export default class ProspectForm extends View {
    constructor(view, data = null, app, { preSubmit = null, postSubmit = null } = {}) {
        super(view);
        this.data = data;
        this.app = app;
        this.preSubmit = preSubmit;
        this.postSubmit = postSubmit;
    }

    #form = null;

    #isEmailValid = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    }

    #listeners = (iti) => {
        this.#form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const notification = new Notification({
                type: 'loading',
            });
            notification.open();

            const formData = new FormData(e.target);
            const body = {
                id: this.data.id,
                store: this.data.store,
            };
            const submitCustomer = formData.get('assign_to_customer_group') ? 1 : 0;

            for (const [key, value] of formData.entries()) {
                if (key == 'phone') {
                    body[key] = iti.getNumber();
                } else if (key == 'assign_to_customer_group') {
                    continue;
                } else {
                    body[key] = value; 
                }
            }

            if (this.preSubmit) {
                this.preSubmit(body);
            }

            const { data, status, message } = await this.app.service.saveProspect(body, {customer: submitCustomer});

            if (this.postSubmit) {
                this.postSubmit({data, status, message});
            }

            if (data.prospect) {
                notification.close();
                this.close();
            } else {
                notification.reload({
                    type: 'error',
                    title: message
                });
            }
        });

        this.#form.addEventListener('click', (e) => {
            if (e.target.id == 'prospect-cancel') {
                this.close();
            }
        });

        const infoBox = document.querySelector("#prospect-form-customer-group-info");
        const customerGroupSelect = this.#form.querySelector('#form-prospect-customer-group');
        const emailInput = this.#form.querySelector('#form-prospect-email');

        const handleEmailChange = (email) => {
            if (!infoBox) return;

            if (this.#isEmailValid(email)) {
                infoBox.classList.add("is-hidden");
                if (customerGroupSelect) {
                    customerGroupSelect.disabled = false;
                    customerGroupSelect.value = 0;
                }
            } else {
                infoBox.classList.remove("is-hidden");

                if (customerGroupSelect) {
                    customerGroupSelect.disabled = true;
                }
            }
        };

        if (emailInput) {
            this.#form.addEventListener("input", (e) => {
                if (e.target === emailInput) {
                    handleEmailChange(e.target.value.trim());
                }
            });
        }

        this.#form.addEventListener('change', (e) => {
            if (e.target.id == 'form-prospect-assign-customer-group') {
                customerGroupSelect.disabled = !e.target.checked;
                if (!e.target.checked) {
                    customerGroupSelect.value = 0;
                }
            }
        });
    };

    open() {
        this.#form = this.view.update(prospectFormHndb(this.data)).modalContainer;
        this.view.open();

        const cc = 'uy' ?? null;

        const iti = intlTelInput(
            this.#form.querySelector('#form-prospect-phone'),
            {
                initialCountry: cc ? cc : 'auto',
                loadUtils: () => import('intl-tel-input/build/js/utils'),
                geoIpLookup: cc
                    ? null
                    : (success, failure) => {
                          fetch('https://ipapi.co/json')
                              .then((res) => res.json())
                              .then((data) => success(data.country_code))
                              .catch(() => failure());
                      },
            }
        );

        this.#listeners(iti);
    }
}
